export default __webpack_public_path__ + "49f26e961ba7377c5026431a7287e640.png";